import { render } from "./SwiperSlide.vue?vue&type=template&id=43a9f55e&scoped=true"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"

import "./SwiperSlide.vue?vue&type=style&index=0&id=43a9f55e&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a9f55e"]])

export default __exports__